import styled from 'styled-components';
import { TextStyle } from 'components/text';

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;

  ${TextStyle} {
    overflow: hidden;
  }
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 14px;
  width: 14px;
`;
